import { render, staticRenderFns } from "./voteList.vue?vue&type=template&id=0336a8ae&scoped=true"
import script from "./voteList.vue?vue&type=script&lang=js"
export * from "./voteList.vue?vue&type=script&lang=js"
import style0 from "./voteList.vue?vue&type=style&index=0&id=0336a8ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0336a8ae",
  null
  
)

export default component.exports